module.exports = __webpack_public_path__ + "img/dep_alcoholicbeverage.544bd734.png";